export function ForbiddenPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-2 text-center">
      <h1 className="text-3xl font-semibold text-slate-900">403</h1>
      <p className="text-slate-500">No tienes permiso para acceder a esta sección.</p>
    </div>
  );
}
